export default __webpack_public_path__ + "static/media/twitter.7379a0d4.svg";